import React from 'react';

const ResetFiltersButton = ({ onClick }) => {
  return (
    <button
      className="border text-[#76A140] h-[40px] rounded-md px-4 py-2 text-[14px] w-[137px] font-itcmedium "
      onClick={onClick}
    >
      Reiniciar filtros
    </button>
  );
};

export default ResetFiltersButton;
